export default __webpack_public_path__ + "static/media/MidSwing.a87a64c5.png";